
import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

export function useCarouselPosts(limit = 3) {
  const [posts, setPosts] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCarouselPosts = async () => {
      setLoading(true);

      try {
        // Fetch published blog posts with featured images
        const { data, error } = await supabase
          .from('blog_posts')
          .select('id, title, slug, featured_image, excerpt')
          .eq('status', 'published')
          .not('featured_image', 'is', null)
          .order('created_at', { ascending: false })
          .limit(limit);

        if (error) throw error;
        
        setPosts(data || []);
      } catch (err) {
        console.error('Error fetching carousel posts:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchCarouselPosts();
  }, [limit]);

  return { posts, loading };
}
